import Image from 'next/image';
import { useTranslations } from 'next-intl';

import ListingAddress from '@/features/listing/components/listing-card/listing-address/listing-address';
import ListingRate from '@/features/listing/components/listing-card/listing-rate/listing-rate';
import ListingMessage from '@/features/listing/components/listing-message/listing-message';
import { type ListingWithUser } from '@/features/listing/types/listing-types';
import { type MessageSentSource } from '@/shared/types/report-types';

import styles from './listing-message-modal.module.scss';

interface ListingMessageModalProps {
  listing: ListingWithUser;
  onClose: () => void;
  messageSrc?: MessageSentSource,
}

export default function ListingMessageModal(props: ListingMessageModalProps) {
  const {
    listing,
    messageSrc,
    onClose,
  } = props;

  const listingMessageModalTranslations = useTranslations('listing.message');

  const closeModalAfterSuccessTime = 2000;

  const handleClose = () => {
    setTimeout(() => {
      onClose();
    }, closeModalAfterSuccessTime);
  };

  const imageUrl = new URL(listing.images[0].path);
  imageUrl.searchParams.set('auto', 'webp');
  imageUrl.searchParams.set('width', (372).toString());
  imageUrl.searchParams.set('quality', (30).toString());

  return (
    <div className={styles.listingMessageModal}>
      <div className={styles.listingMessageModal_title}>
        {listingMessageModalTranslations('message-to')}
        {' '}
        {listing.user.firstName}
      </div>

      <div className={styles.listingMessageModal_card}>
        <div className={styles.listingMessageModal_image}>
          <Image
            src={imageUrl.toString()}
            alt={listing.title}
            fill
            unoptimized
            style={{ objectFit: 'cover' }}
          />
        </div>

        <div className={styles.listingMessageModal_details}>
          <div className={styles.listingMessageModal_listingTitle}>
            {listing.title}
          </div>

          <ListingAddress address={listing.addressFormatted} listingTypeId={listing.listingTypeId} />

          <ListingRate rate={listing.rates} />
        </div>
      </div>

      <ListingMessage listing={listing} onSent={handleClose} messageSrc={messageSrc} />
    </div>
  );
}
